import { API_URL_V1, API_URL_V2 } from "../constants";

export const storesAvailable = (lat: number, lng: number) =>
  `${API_URL_V1}/available-stores?lat=${lat}&lng=${lng}`;

export const catalogInternational = (storeId: number) =>
  `${API_URL_V1}/stores/${storeId}/international-catalog/`;

export const coverageZones = `${API_URL_V2}/stores/`;
